import styled from 'styled-components'
import { MdClose } from 'react-icons/md'

export const CloseCheckoutModalBtn = styled(MdClose)`
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 52px;
  height: 52px;
  z-index: 10;
  border-radius: 50px;
`

export const CheckoutWrapper = styled.div`
  width: 440px;
  padding: 30px 10px;
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%;
  .create {
    font-weight: 600;
    font-style: normal;
    font-size: ${({ theme }) => theme.fontSize.s};
    line-height: 140%;
    color: ${({ theme }) => theme.colors.CollaboBlue};
    margin-top: 30px;
  }
  .header {
    h3 {
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.x1};
      line-height: 140%;
      color: ${({ theme }) => theme.colors.black};
    }
    p {
      font-style: normal;
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x5};
      line-height: 140%;
      color: ${({ theme }) => theme.colors.profileBlack};
    }
  }
  .checkout_details_flex {
    .flex_one {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: -10px;
      h3 {
        font-style: normal;
        font-weight: 400;
        font-size: ${({ theme }) => theme.fontSize.x5};
        line-height: 140%;
        color: ${({ theme }) => theme.colors.profileBlack};
      }
      p {
        font-style: normal;
        font-weight: 600;
        font-size: ${({ theme }) => theme.fontSize.x5};
        line-height: 140%;
        color: ${({ theme }) => theme.colors.navyBlue};
      }
    }
  }

  .pin_wrapper {
    margin-bottom: 3rem;
    p {
      font-style: normal;
      font-weight: 400;
      font-size: ${({ theme }) => theme.fontSize.x5};
      line-height: 140%;
      color: ${({ theme }) => theme.colors.profileBlack};
    }
  }
`

export const CheckoutModalContainer = styled.div`
  /* overflow-y: scroll; */

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    height: 70%;
  }
`

export const CheckoutModalBackground = styled.div`
  width: 500px;
  background: ${({ theme }) => theme.colors.white};
  z-index: 90;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  overflow-y: scroll;

  @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
    width: 100%;
    top: 100px;
    border-radius: 40px 40px 0px 0px;
  }
`

// export const WithdrawComponent = styled.div`
//   margin-top: 3rem;
// `
